import { render } from "./DadosFinanceiros.vue?vue&type=template&id=acb1f9f8&scoped=true"
import script from "./DadosFinanceiros.vue?vue&type=script&lang=js"
export * from "./DadosFinanceiros.vue?vue&type=script&lang=js"

import "./DadosFinanceiros.vue?vue&type=style&index=0&id=acb1f9f8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acb1f9f8"]])

export default __exports__